import { NavLink } from "react-router-dom";
import { useAuth } from "../App";
import "./Sidebar.css";

import dashboard from "../assets/icons/dashboard.png";
import profile from "../assets/icons/profile.png";
import article from "../assets/icons/article.png";
import judgement from "../assets/icons/judgement.png";
import judge from "../assets/icons/judge.png";
import act from "../assets/icons/act.png";
import user from "../assets/icons/advocate.png";
import settings from "../assets/icons/dashboard.png";
import journalIcon from "../assets/icons/journal.png";

export default function Sidebar({ isOpen, onClose, disabled = false }) {
  // 🔒 SAFETY: ensure auth is always an object
  const auth = useAuth() || {};

  const canAccess =
    typeof auth.canAccess === "function" ? auth.canAccess : () => false;

  const usertype = auth.usertype || "";
  const uid = auth.uid || "";

  const isAdmin = usertype === "Admin";

  // ✅ SAFE menu construction (no fragile spread on unknown values)
  const menuItems = [];

  menuItems.push({
    label: "Dashboard",
    path: "/",
    icon: dashboard,
    end: true,
  });

  if (canAccess("profile")) {
    menuItems.push({ label: "Profile", path: "/profile", icon: profile });
  }

  if (canAccess("article")) {
    menuItems.push({ label: "Article", path: "/article", icon: article });
  }

  if (canAccess("judgement")) {
    menuItems.push({
      label: "Judgment",
      path: "/judgement",
      icon: judgement,
    });
  }

  if (canAccess("judge")) {
    menuItems.push({ label: "Judge", path: "/judge", icon: judge });
  }

  if (canAccess("act")) {
    menuItems.push({ label: "Act", path: "/act", icon: act });
  }

  if (canAccess("journal")) {
    menuItems.push({
      label: "Journal",
      path: "/journal",
      icon: journalIcon,
    });
  }

  if (canAccess("user")) {
    menuItems.push({ label: "User", path: "/user", icon: user });
  }

  if (isAdmin) {
    menuItems.push({
      label: "Admin Settings",
      path: "/admin/settings",
      icon: settings,
    });
  }

  return (
    <aside className={`sidebar ${isOpen ? "active" : ""}`}>
      {!disabled && (
        <button className="close-btn" onClick={onClose}>
          ✕
        </button>
      )}

      {/* USER INFO */}
      <ul className="menu">
        <li className="menu-userinfo">
          <span className="userinfo-text">
            {usertype}
            {uid && " | "}
            {uid}
          </span>
        </li>
      </ul>

      {/* MENU */}
      <ul className={`menu ${disabled ? "menu-disabled" : ""}`}>
        {menuItems.map((item) => (
          <NavLink
            key={item.label}
            to={item.path}
            end={item.end}
            className={({ isActive }) =>
              `menu-link ${isActive ? "active" : ""}`
            }
            onClick={() => {
              if (window.innerWidth <= 768) onClose?.();
            }}
          >
            <li>
              <img src={item.icon} alt="" className="menu-icon" />
              <span>{item.label}</span>
            </li>
          </NavLink>
        ))}
      </ul>
    </aside>
  );
}